// src/components/device-components/DeviceTypeGrid.jsx
import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import DeviceTypeCard from "./DeviceTypeCard";

const DeviceTypeGrid = ({ deviceTypes, onEdit, onDelete, loading = false }) => {
  const itemsToRender = loading ? Array.from({ length: 6 }) : deviceTypes;

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
        gap: 2,
      }}
    >
      {itemsToRender.map((deviceType, idx) => (
        <DeviceTypeCard
          key={loading ? idx : deviceType.id}
          deviceType={deviceType}
          onEdit={onEdit}
          onDelete={onDelete}
          loading={loading}
        />
      ))}
    </Box>
  );
};

DeviceTypeGrid.propTypes = {
  deviceTypes: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default DeviceTypeGrid;
